<template>
  <drag-base :w="width" :h="height" :x="parseInt(left)" :y="parseInt(top)" v-on:dragstop="stopDrag"
                           v-on:resizestop="stopResize" :parent="true" :snap-grid="snapGrid" :id="id" :droppable="droppable">
      <stickie-content v-bind="note" :note="note"></stickie-content>
  </drag-base>
</template>

<script>

import DragBase from '@/components/graphicalsensorview/DragBase'
import StickieContent from './StickieContent'

export default {
  name: 'SensorValueLabel',
  props: {
    id:{},
    backgroundColor: {type:String, default: '#ff00ff'},
    left: {type: Number, default: 100},
    top: {type: Number, default: 50},
    label: String,
    width: {type: Number, default: 300},
    height: {type: Number, default: 200},
    note: Object,
    snapGrid: {type: Boolean, default: false},
    droppable: {type: Boolean, defualt: false}
  },
  components: { StickieContent, DragBase},
  computed: {
    commentMarked () {
      return ''
    },
    newBGC () {
      return {
        backgroundColor: this.newBackgroundColor
      }
    },
    bgc () {
      return {
        backgroundColor: this.backgroundColor
      }
    },
  },
  data () {
    return {
      x: this.left,
      y: this.top,
      currentWidth: this.width,
      currentHeight: this.height,
      currentBackgroundColor: this.backgroundColor,
      currentContent: this.content,
      currentURL: this.url,
      newBackgroundColor: this.backgroundColor,
      newContent: this.content,
      currentComment: this.comment,
      newComment: this.comment,
      currentAtBackground: !!this.atBackground, // null to false
      newAtBackground: !!this.atBackground, // null to false
      newURL: this.url,
      dialog: false,
      params: null
    }
  },
  methods: {

    stopResize: function (x, y, width, height) {
      this.x = x
      this.y = y
      this.currentWidth = width
      this.currentHeight = height
      this.updateStore()
    },
    stopDrag: function (x, y) {
      this.x = x
      this.y = y
      this.updateStore()
    },
    updateStore: function () {
      let note = this.note
      note.top = this.y
      note.left = this.x
      note.width = this.currentWidth
      note.height = this.currentHeight
      this.$store.commit('editStickie', note)
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
  .stickie {
    position: absolute;
    width: 100%;
    height: 100%;

    display: flex;
    flex-flow: column;
  }

  .stickie-content {
    height: 100%;
    overflow: auto;
    text-align: left;
  }
  .stickie-content p {
    padding:0;
    margin:0;

  }
    .stickie {
    display: flex;
    flex-flow: column;
    width: 100%;
    height: 100%;
  }

  .stickie-content {
    height: 100%;
    overflow: auto;
    text-align: left;
  }
  .stickie-content p {
    padding:0;
    margin:0;

  }
</style>

